<template>
    <van-nav-bar title="Authenticating..." />
</template>
<script>
import { Toast, NavBar } from 'vant';

export default {
    name: 'Uauth',
    data () {
        return {
        }
    },
    mounted() {
        Toast.loading({
            duration: 1,
            message: '认证中...',
            forbidClick: true
        });
    },
    watch: {
        $uauth: function (val) {
            //console.log("To path:", this.$route.query.to);
            if (val == 1) {
                this.$router.replace({
                    path: this.$route.query.to,
                    query: {
                        form: 'wechat'
                    }
                });
            } else if (val == -1) {
                this.$router.replace({
                    path: '/forbidden',
                    query: {
                        form: 'wechat'
                    }
                });
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Uauth.vue